import {
  Component,
} from "react";
import store from "CommonState/store";
import uiconfig from "CommonState/uiconfig";
import antragApi from "Apis/antrag-api";
import {
  Panel,
  Spinner,
} from "CommonComponents/bricks";
import PersonBeschaeftigungTab from "App/person-beschaeftigung-tab";
import {
  ANTRAGSTATUS,
  VERTRAGSARTEN_LEHRAUFTRAG,
} from "App/constants";

@uiconfig
@store("user")
@antragApi.current
export default class AntragVerwaltenBeschaeftigungTab extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { currentAntrag } = this.props;

    const istLehrauftrag = currentAntrag.a_artid == VERTRAGSARTEN_LEHRAUFTRAG;

    if (!currentAntrag) {
      return <Spinner />;
    }

    const eingereicht = [ANTRAGSTATUS.STATUS_NEU].indexOf(currentAntrag.a_asid) < 0;

    return <div>
      { !eingereicht &&
          <span>
            <Panel className='box-panel'>Folgende Daten zu weiteren {istLehrauftrag ? "Lehraufträgen" : "Beschäftigungsverhältnissen"} werden mit dem Antrag zusammen eingereicht. Bitte prüfen Sie alle Daten vor dem Einreichen.</Panel>
            <PersonBeschaeftigungTab />
          </span> }
      { eingereicht &&
          <span>
            <Panel className='box-panel'>Folgende Daten wurden mit dem Antrag zusammen eingereicht.</Panel>
            <PersonBeschaeftigungTab antrag={ currentAntrag } />
          </span>
      }
    </div>;
  }
}
